import { render } from "./UpdateBirthdayInfoView.vue?vue&type=template&id=a15f6d5c"
import script from "./UpdateBirthdayInfoView.vue?vue&type=script&lang=js"
export * from "./UpdateBirthdayInfoView.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Mobile\\mobile\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__